import React from "react";
import { Button } from "@/components/ui/button";

export const PhoneMockup = () => {
  return (
    <div className="relative w-full max-w-[320px] mx-auto">
      <div className="relative rounded-[2.5rem] border-8 border-gray-900 overflow-hidden shadow-2xl transform scale-90">
        <div className="absolute top-0 inset-x-0 h-6 bg-gray-900 z-10"></div>
        <div className="h-[620px] w-full bg-white overflow-hidden">
          <div className="flex flex-col h-full">
            <div className="bg-white p-4 flex items-center justify-between border-b">
              <div>
                <h3 className="font-bold text-savyi-purple">Savyi</h3>
                <p className="text-xs text-gray-500">Your Financial Hype Squad</p>
              </div>
              <div className="w-8 h-8 rounded-full bg-gradient-purple flex items-center justify-center text-white font-bold">
                J
              </div>
            </div>
            
            <div className="flex-1 p-4 flex flex-col gap-4 bg-gray-50">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <h3 className="font-medium text-sm mb-2">Financial Health</h3>
                <div className="flex items-center gap-2 mb-2">
                  <div className="h-2.5 flex-1 bg-gray-200 rounded-full">
                    <div className="h-2.5 w-4/5 bg-gradient-to-r from-blue-600 to-purple-500 rounded-full"></div>
                  </div>
                  <span className="text-sm font-medium">80%</span>
                </div>
                <p className="text-xs text-gray-500">Almost there! Just pay your utility bill to reach 85%.</p>
              </div>
              
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <h3 className="font-medium text-sm mb-3">Urgent Deadlines</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-red-100 flex items-center justify-center text-savyi-red">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
                        <line x1="16" x2="16" y1="2" y2="6"></line>
                        <line x1="8" x2="8" y1="2" y2="6"></line>
                        <line x1="3" x2="21" y1="10" y2="10"></line>
                        <path d="m9 16 2 2 4-4"></path>
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium">Electricity Bill</p>
                      <p className="text-xs text-red-500">Due in 2 days</p>
                    </div>
                    <div className="text-sm font-medium">£89.99</div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-yellow-100 flex items-center justify-center text-savyi-yellow">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
                        <line x1="16" x2="16" y1="2" y2="6"></line>
                        <line x1="8" x2="8" y1="2" y2="6"></line>
                        <line x1="3" x2="21" y1="10" y2="10"></line>
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-medium">Car Insurance</p>
                      <p className="text-xs text-yellow-500">Due in 5 days</p>
                    </div>
                    <div className="text-sm font-medium">£142.50</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-purple rounded-xl p-4 shadow-sm text-white">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-sm">Scan & Slay</h3>
                  <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                      <circle cx="12" cy="13" r="3"></circle>
                    </svg>
                  </div>
                </div>
                <p className="text-xs text-white/80 mb-3">Scan receipts, bills, or any financial document.</p>
                <Button className="w-full rounded-lg text-xs bg-white text-savyi-purple hover:bg-white/90">
                  Take a Photo
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 bg-gray-800 rounded-full"></div>
      </div>
      
      <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-[400px] h-full bg-blue-500/10 rounded-[3rem] blur-3xl"></div>
    </div>
  );
};
